import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { MdUpload, MdClose, MdPalette } from 'react-icons/md';
import { HeroEstilo, Secoes, SiteEmpresaDto, obterUrlImagemPreview, uploadLogo } from '../../services/meuSiteService';

const AZUL = '#1F467E';
const BORDA = '#e2e8f0';
const FUNDO = '#f5f7fa';

const COR_PRIMARIA_PADRAO = '#1F467E';
const COR_SECUNDARIA_PADRAO = '#0E2A52';

const Section = styled.div`
    background: #fff;
    border: 1px solid ${BORDA};
    border-radius: 8px;
    padding: 24px;
    margin-bottom: 20px;
`;

const SectionTitle = styled.h3`
    font-size: 14px;
    font-weight: 600;
    color: ${AZUL};
    margin: 0 0 18px 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

const FieldRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 14px;
    flex-wrap: wrap;
`;

const Label = styled.label`
    font-size: 13px;
    font-weight: 500;
    color: #374151;
    min-width: 160px;
`;

const ColorInput = styled.input`
    width: 44px;
    height: 36px;
    border: 1px solid ${BORDA};
    border-radius: 6px;
    cursor: pointer;
    padding: 2px;
    background: none;
`;

const HexInput = styled.input`
    width: 100px;
    height: 36px;
    border: 1px solid ${BORDA};
    border-radius: 6px;
    padding: 0 10px;
    font-size: 13px;
    font-family: monospace;
    color: #374151;
    &:focus { outline: 2px solid ${AZUL}; }
`;

const TextInput = styled.input`
    flex: 1;
    min-width: 200px;
    height: 36px;
    border: 1px solid ${BORDA};
    border-radius: 6px;
    padding: 0 10px;
    font-size: 13px;
    color: #374151;
    &:focus { outline: 2px solid ${AZUL}; }
`;

const TextAreaInput = styled.textarea`
    flex: 1;
    min-width: 200px;
    border: 1px solid ${BORDA};
    border-radius: 6px;
    padding: 8px 10px;
    font-size: 13px;
    color: #374151;
    resize: vertical;
    rows: 2;
    &:focus { outline: 2px solid ${AZUL}; }
`;

const LogoArea = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
`;

const LogoPreview = styled.img`
    width: 80px;
    height: 80px;
    object-fit: contain;
    border: 1px solid ${BORDA};
    border-radius: 6px;
    background: ${FUNDO};
`;

const LogoPlaceholder = styled.div`
    width: 80px;
    height: 80px;
    border: 1px dashed #cbd5e1;
    border-radius: 6px;
    background: ${FUNDO};
    display: flex;
    align-items: center;
    justify-content: center;
    color: #94a3b8;
    font-size: 12px;
    text-align: center;
    padding: 8px;
`;

const UploadBtn = styled.button`
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    border: 1px solid ${AZUL};
    border-radius: 6px;
    background: #fff;
    color: ${AZUL};
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    &:hover { background: #f0f4fa; }
    &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

const BarraSalvar = styled.div`
    position: sticky;
    top: 0;
    z-index: 10;
    display: flex;
    justify-content: flex-end;
    padding: 8px 0 12px;
    margin-bottom: 8px;
    background: ${FUNDO};
`;

const SaveBtn = styled.button`
    padding: 10px 24px;
    background: ${AZUL};
    color: #fff;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    &:hover { background: #163560; }
    &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

const EstiloGrid = styled.div`
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 16px;
`;

const EstiloBtn = styled.button<{ ativo: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 10px 16px;
    min-width: 96px;
    border: 2px solid ${p => p.ativo ? AZUL : BORDA};
    border-radius: 8px;
    background: ${p => p.ativo ? '#f0f4fa' : '#fff'};
    color: ${p => p.ativo ? AZUL : '#64748b'};
    font-size: 12px;
    font-weight: ${p => p.ativo ? 600 : 500};
    cursor: pointer;
    &:hover { border-color: ${AZUL}; color: ${AZUL}; }
`;

const EstiloAmostra = styled.span<{ fundo: string; borda?: string }>`
    width: 44px;
    height: 22px;
    border-radius: 4px;
    background: ${p => p.fundo};
    border: 1px solid ${p => p.borda || BORDA};
`;

const AjudaTexto = styled.p`
    font-size: 12px;
    color: #64748b;
    margin: 6px 0 0 0;
`;

const LimparBtn = styled.button`
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 6px 10px;
    border: 1px solid ${BORDA};
    border-radius: 6px;
    background: #fff;
    color: #64748b;
    font-size: 12px;
    cursor: pointer;
    &:hover { border-color: #ef4444; color: #ef4444; }
`;

const CoresLogoBox = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    margin-top: 14px;
    padding: 12px 14px;
    background: ${FUNDO};
    border: 1px solid ${BORDA};
    border-radius: 8px;
`;

const CoresLogoTitulo = styled.span`
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 500;
    color: #374151;
`;

const Swatch = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    border: 1px solid ${BORDA};
    border-radius: 6px;
    background: #fff;
    font-size: 12px;
    font-family: monospace;
    color: #374151;
    cursor: pointer;
    &:hover { border-color: ${AZUL}; }
`;

const SwatchCor = styled.span<{ cor: string }>`
    width: 20px;
    height: 20px;
    border-radius: 4px;
    background: ${p => p.cor};
    border: 1px solid ${BORDA};
`;

const UsarCoresBtn = styled.button`
    padding: 7px 14px;
    border: 1px solid ${AZUL};
    border-radius: 6px;
    background: #fff;
    color: ${AZUL};
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    &:hover { background: #f0f4fa; }
`;

interface Props {
    site: SiteEmpresaDto;
    secoes: Secoes;
    onChange: (site: SiteEmpresaDto) => void;
    onSecoesChange: (s: Secoes) => void;
    onSave: () => Promise<void>;
    saving: boolean;
}

interface CoresExtraidas {
    primaria: string;
    secundaria: string;
}

const ESTILOS: { valor: HeroEstilo; label: string; fundo: string; borda?: string }[] = [
    { valor: 'claro', label: 'Claro', fundo: '#f8fafc' },
    { valor: 'escuro', label: 'Escuro', fundo: '#0f172a' },
    { valor: 'primaria', label: 'Cor primária', fundo: AZUL },
    { valor: 'gradiente', label: 'Gradiente', fundo: `linear-gradient(120deg, ${AZUL}, ${COR_SECUNDARIA_PADRAO})` },
];

function extrairMensagem(err: any): string {
    return err?.response?.data?.mensagem
        || err?.response?.data?.Mensagem
        || 'Erro ao realizar operação.';
}

function rgbParaHsl(r: number, g: number, b: number): { h: number; s: number; l: number } {
    const rn = r / 255;
    const gn = g / 255;
    const bn = b / 255;
    const max = Math.max(rn, gn, bn);
    const min = Math.min(rn, gn, bn);
    const l = (max + min) / 2;
    if (max === min) return { h: 0, s: 0, l };
    const d = max - min;
    const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    let h;
    if (max === rn) h = (gn - bn) / d + (gn < bn ? 6 : 0);
    else if (max === gn) h = (bn - rn) / d + 2;
    else h = (rn - gn) / d + 4;
    return { h: h * 60, s, l };
}

function rgbParaHex(r: number, g: number, b: number): string {
    const canal = (v: number) => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, '0');
    return `#${canal(r)}${canal(g)}${canal(b)}`.toUpperCase();
}

function distanciaMatiz(a: number, b: number): number {
    const diff = Math.abs(a - b) % 360;
    return diff > 180 ? 360 - diff : diff;
}

function extrairCoresDaImagem(img: HTMLImageElement): CoresExtraidas | null {
    const canvas = document.createElement('canvas');
    canvas.width = 64;
    canvas.height = 64;
    const ctx = canvas.getContext('2d');
    if (!ctx) return null;
    ctx.drawImage(img, 0, 0, 64, 64);
    const { data } = ctx.getImageData(0, 0, 64, 64);
    const buckets = new Map<string, { score: number; count: number; r: number; g: number; b: number }>();
    for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        const a = data[i + 3];
        if (a < 128) continue;
        if (r > 235 && g > 235 && b > 235) continue;
        if (r < 25 && g < 25 && b < 25) continue;
        const { s } = rgbParaHsl(r, g, b);
        if (s < 0.15) continue;
        const chave = `${r >> 4}-${g >> 4}-${b >> 4}`;
        const bucket = buckets.get(chave) || { score: 0, count: 0, r: 0, g: 0, b: 0 };
        bucket.score += s;
        bucket.count += 1;
        bucket.r += r;
        bucket.g += g;
        bucket.b += b;
        buckets.set(chave, bucket);
    }
    const ordenados = Array.from(buckets.values()).sort((a, b) => b.score - a.score);
    if (ordenados.length === 0) return null;
    const mediaRgb = (bk: { count: number; r: number; g: number; b: number }) => ({
        r: bk.r / bk.count,
        g: bk.g / bk.count,
        b: bk.b / bk.count,
    });
    const prim = mediaRgb(ordenados[0]);
    const primaria = rgbParaHex(prim.r, prim.g, prim.b);
    const matizPrimaria = rgbParaHsl(prim.r, prim.g, prim.b).h;
    let secundaria: string | null = null;
    for (let i = 1; i < ordenados.length; i++) {
        const cand = mediaRgb(ordenados[i]);
        const matiz = rgbParaHsl(cand.r, cand.g, cand.b).h;
        if (distanciaMatiz(matiz, matizPrimaria) > 30) {
            secundaria = rgbParaHex(cand.r, cand.g, cand.b);
            break;
        }
    }
    if (!secundaria) secundaria = rgbParaHex(prim.r * 0.65, prim.g * 0.65, prim.b * 0.65);
    return { primaria, secundaria };
}

function extrairCoresDaLogo(arquivo: File): Promise<CoresExtraidas | null> {
    return new Promise(resolve => {
        const url = URL.createObjectURL(arquivo);
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
            let cores: CoresExtraidas | null = null;
            try {
                cores = extrairCoresDaImagem(img);
            } catch {
                cores = null;
            }
            URL.revokeObjectURL(url);
            resolve(cores);
        };
        img.onerror = () => {
            URL.revokeObjectURL(url);
            resolve(null);
        };
        img.src = url;
    });
}

export function AbaAparencia({ site, secoes, onChange, onSecoesChange, onSave, saving }: Props) {
    const logoInputRef = useRef<HTMLInputElement>(null);
    const [uploadingLogo, setUploadingLogo] = useState(false);
    const [coresLogo, setCoresLogo] = useState<CoresExtraidas | null>(null);

    const [logoUrl, setLogoUrl] = useState<string | null>(null);

    useEffect(() => {
        let ativo = true;
        if (!site.logoArquivoId) {
            setLogoUrl(null);
            return;
        }
        obterUrlImagemPreview(site.logoArquivoId).then(url => {
            if (ativo) setLogoUrl(url);
        });
        return () => { ativo = false; };
    }, [site.logoArquivoId]);

    const estiloAtual: HeroEstilo = secoes.hero.estilo || (site.categoria === 2 ? 'escuro' : 'claro');
    const corFundoLivre = secoes.hero.corFundo || null;

    const handleLogoUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setUploadingLogo(true);
        try {
            const res = await uploadLogo(file);
            const cores = await extrairCoresDaLogo(file);
            const coresAindaPadrao =
                (site.corPrimaria || '').toUpperCase() === COR_PRIMARIA_PADRAO
                && (site.corSecundaria || '').toUpperCase() === COR_SECUNDARIA_PADRAO;
            if (cores && coresAindaPadrao) {
                onChange({
                    ...site,
                    logoArquivoId: res.data.arquivoId,
                    corPrimaria: cores.primaria,
                    corSecundaria: cores.secundaria,
                });
                setCoresLogo(null);
                toast.success('Logo atualizada com sucesso.');
                toast.info('Cores extraídas da logo aplicadas. Ajuste se quiser e salve.');
            } else {
                onChange({ ...site, logoArquivoId: res.data.arquivoId });
                setCoresLogo(cores);
                toast.success('Logo atualizada com sucesso.');
            }
        } catch (err) {
            toast.error(extrairMensagem(err));
        } finally {
            setUploadingLogo(false);
            if (logoInputRef.current) logoInputRef.current.value = '';
        }
    };

    const aplicarCoresLogo = () => {
        if (!coresLogo) return;
        onChange({ ...site, corPrimaria: coresLogo.primaria, corSecundaria: coresLogo.secundaria });
    };

    return (
        <div>
            <BarraSalvar>
                <SaveBtn onClick={onSave} disabled={saving}>
                    {saving ? 'Salvando...' : 'Salvar aparência'}
                </SaveBtn>
            </BarraSalvar>
            <Section>
                <SectionTitle>Cores</SectionTitle>
                <FieldRow>
                    <Label>Cor primária</Label>
                    <ColorInput
                        type="color"
                        value={site.corPrimaria || '#1F467E'}
                        onChange={e => onChange({ ...site, corPrimaria: e.target.value })}
                    />
                    <HexInput
                        value={site.corPrimaria || ''}
                        maxLength={7}
                        onChange={e => onChange({ ...site, corPrimaria: e.target.value })}
                        placeholder="#1F467E"
                    />
                </FieldRow>
                <FieldRow>
                    <Label>Cor secundária</Label>
                    <ColorInput
                        type="color"
                        value={site.corSecundaria || '#0E2A52'}
                        onChange={e => onChange({ ...site, corSecundaria: e.target.value })}
                    />
                    <HexInput
                        value={site.corSecundaria || ''}
                        maxLength={7}
                        onChange={e => onChange({ ...site, corSecundaria: e.target.value })}
                        placeholder="#0E2A52"
                    />
                </FieldRow>
            </Section>

            <Section>
                <SectionTitle>Seção principal</SectionTitle>
                <EstiloGrid>
                    {ESTILOS.map(op => (
                        <EstiloBtn
                            key={op.valor}
                            type="button"
                            ativo={!corFundoLivre && estiloAtual === op.valor}
                            onClick={() => onSecoesChange({ ...secoes, hero: { ...secoes.hero, estilo: op.valor } })}
                        >
                            <EstiloAmostra fundo={op.fundo} borda={op.borda} />
                            {op.label}
                        </EstiloBtn>
                    ))}
                </EstiloGrid>
                <FieldRow>
                    <Label>Cor de fundo livre</Label>
                    <ColorInput
                        type="color"
                        value={corFundoLivre || '#FFFFFF'}
                        onChange={e => onSecoesChange({ ...secoes, hero: { ...secoes.hero, corFundo: e.target.value } })}
                    />
                    {corFundoLivre && (
                        <>
                            <HexInput
                                value={corFundoLivre}
                                maxLength={7}
                                onChange={e => onSecoesChange({ ...secoes, hero: { ...secoes.hero, corFundo: e.target.value } })}
                            />
                            <LimparBtn type="button" onClick={() => onSecoesChange({ ...secoes, hero: { ...secoes.hero, corFundo: null } })}>
                                <MdClose size={13} />
                                Limpar
                            </LimparBtn>
                        </>
                    )}
                </FieldRow>
                <AjudaTexto>
                    Quando definida, a cor de fundo livre substitui o estilo escolhido acima.
                </AjudaTexto>
            </Section>

            <Section>
                <SectionTitle>Logo</SectionTitle>
                <LogoArea>
                    {logoUrl ? (
                        <LogoPreview src={logoUrl} alt="Logo" />
                    ) : (
                        <LogoPlaceholder>Sem logo</LogoPlaceholder>
                    )}
                    <UploadBtn
                        type="button"
                        disabled={uploadingLogo}
                        onClick={() => logoInputRef.current?.click()}
                    >
                        <MdUpload size={16} />
                        {uploadingLogo ? 'Enviando...' : 'Enviar logo'}
                    </UploadBtn>
                    <input
                        ref={logoInputRef}
                        type="file"
                        accept="image/*"
                        style={{ display: 'none' }}
                        onChange={handleLogoUpload}
                    />
                </LogoArea>
                {coresLogo && (
                    <CoresLogoBox>
                        <CoresLogoTitulo>
                            <MdPalette size={16} color={AZUL} />
                            Cores encontradas na logo
                        </CoresLogoTitulo>
                        <Swatch type="button" title="Aplicar como cor primária" onClick={() => onChange({ ...site, corPrimaria: coresLogo.primaria })}>
                            <SwatchCor cor={coresLogo.primaria} />
                            {coresLogo.primaria}
                        </Swatch>
                        <Swatch type="button" title="Aplicar como cor secundária" onClick={() => onChange({ ...site, corSecundaria: coresLogo.secundaria })}>
                            <SwatchCor cor={coresLogo.secundaria} />
                            {coresLogo.secundaria}
                        </Swatch>
                        <UsarCoresBtn type="button" onClick={aplicarCoresLogo}>
                            Usar cores da logo
                        </UsarCoresBtn>
                    </CoresLogoBox>
                )}
            </Section>

            <Section>
                <SectionTitle>Contato e Localização</SectionTitle>
                <FieldRow>
                    <Label>WhatsApp comercial</Label>
                    <TextInput
                        value={site.whatsappComercial || ''}
                        placeholder="+55 DDD número"
                        onChange={e => onChange({ ...site, whatsappComercial: e.target.value })}
                    />
                </FieldRow>
                <FieldRow>
                    <Label>Instagram</Label>
                    <TextInput
                        value={site.instagram || ''}
                        placeholder="@perfil"
                        onChange={e => onChange({ ...site, instagram: e.target.value })}
                    />
                </FieldRow>
                <FieldRow>
                    <Label>Facebook</Label>
                    <TextInput
                        value={site.facebook || ''}
                        placeholder="facebook.com/pagina"
                        onChange={e => onChange({ ...site, facebook: e.target.value })}
                    />
                </FieldRow>
                <FieldRow style={{ alignItems: 'flex-start' }}>
                    <Label style={{ paddingTop: 8 }}>Endereço exibido</Label>
                    <TextAreaInput
                        value={site.enderecoExibido || ''}
                        rows={2}
                        onChange={e => onChange({ ...site, enderecoExibido: e.target.value })}
                        placeholder="Rua, número, bairro, cidade"
                    />
                </FieldRow>
            </Section>
        </div>
    );
}
